import Login from './Login';
// import Login from './Login';

const Index = ({ activeIndex, setActiveIndex }) => {
  return (
    <div className="relative h-screen overflow-hidden bg-gradient-to-br from-brand-400 to-brand-600">
      {/* Square Shapes */}
      <div className="absolute left-10 top-10 h-20 w-20 rotate-45 transform bg-white bg-opacity-10 md:h-40 md:w-40"></div>
      <div className="absolute right-20 top-32 h-32 w-32 rotate-12 transform bg-white bg-opacity-10 md:h-64 md:w-64"></div>
      <div className="absolute bottom-20 left-20 h-16 w-16 rotate-6 transform bg-white bg-opacity-10 md:h-32 md:w-32"></div>
      <div className="rotate-30 absolute bottom-10 right-10 h-24 w-24 transform bg-white bg-opacity-10 md:h-48 md:w-48"></div>
      <div className="rotate-8 absolute left-1/2 top-1/2 h-28 w-28 -translate-x-1/2 -translate-y-1/2 transform bg-white bg-opacity-10 md:h-56 md:w-56"></div>
      {/* traingle && circle Shapes */}
      <div className="absolute right-1/4 top-16 h-10 w-10 rounded-full bg-white bg-opacity-10 md:h-20 md:w-20"></div>
      <div className="absolute bottom-32 left-1/3 h-10 w-10 rounded-full bg-white bg-opacity-10 md:h-20 md:w-20"></div>
      <div className="border-l-10 border-r-10 border-b-20 border-transparent md:border-l-20 md:border-r-20 md:border-b-40 absolute bottom-40 right-1/2 h-0 w-0 rotate-45 transform border-b-white border-opacity-10"></div>
      <div className="border-l-10 border-r-10 border-b-20 border-transparent md:border-l-20 md:border-r-20 md:border-b-40 absolute left-1/4 top-1/4 h-0 w-0 rotate-12 transform border-b-white border-opacity-10"></div>
      {/* Your content */}
      <div className="relative flex h-full items-center justify-center overflow-hidden">
        <div className="relative flex h-full w-full items-center justify-center">
          <div>
            <Login />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
